import React from "react";
import withIconComponent from "../withIconComponent";

var ArrowLeft = function ArrowLeft() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12H2",
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19l-7-7 7-7",
    strokeLinecap: "square"
  }));
};

export default withIconComponent("UiArrowLeft", false)(ArrowLeft);